import { apiSlice } from '../../app/api/apiSlice'

export const finderApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFinderInfo: builder.query ({
      query: (salesrep_id) => `v1/finders/info/${salesrep_id}`,
      keepUnusedDataFor: 1
    }),
    createFinder: builder.mutation ({
      query: (data) => ({
        url: `v1/finders/register`,
        method: 'POST',
        body: data
      })
    }),
    validateDiscount: builder.query ({
      query: (discount_id) => `v2/discounts/validate/${discount_id}`,
      keepUnusedDataFor: 0,
      providesTags: ["Discount"]
    }),
  }),
})


export const {
  useGetFinderInfoQuery,
  useCreateFinderMutation,
  useValidateDiscountQuery
} = finderApi
